/* eslint-disable eqeqeq */
/* eslint-disable no-mixed-operators */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import { Divider, Grid, Typography, useMediaQuery } from '@mui/material'
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
//
import { BtnAddForm, BtnBack, BtnConfirm, BtnDraft, BtnHome, BtnRecycle, BtnRejectPart, BtnSave, BtnSend, BtnUpdate } from 'components/Common/Button';
import { AlertMsgTh, AlertTitleTh, AlertTitle, AxiosGet, AxiosPost, Extension, ResultAPI } from 'service/CommonFunction/TS_function';
import CpnDataRequest from './ComponentVOC/CpnDataRequest';
import CpnTypeRequestComplaint from './ComponentVOC/CpnTypeRequestComplaint';
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import { SnackbarCustom } from 'components/Common/Alert/Snackbars/Snackbar';
import InnerHeadRoutes from 'components/Common/InnerHeadRoutes/InnerHeadRoutes';
import { BiEdit } from "react-icons/bi";
import VerticalStepper from 'components/Stepper/VerticalStepper';
import CpnResponPersonNew from './ComponentVOC/CpnResponPerson_new';
import CpnTypeRequest from './ComponentVOC/CpnTypeRequest';
import CpnAlertEmail from './ComponentVOC/CpnAlertEmail';


const ReferDetailVOC = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const Layout1300 = useMediaQuery('(min-width:1300px)');

    //useState
    const [schemaObj, setSchemaObj] = useState({} as any);

    const [sVOCFormID, setsVOCFormID] = useState(params['sID'] ?? null)
    const [nJobTypeID, setnJobTypeID] = useState(0)
    const [sMode, setsMode] = useState("view")  //Edit, View, Super
    const [sStatusForm, setsStatusForm] = useState(null)
    const [nAlertCount, setnAlertCount] = useState(0)
    const [sCustomer, setsCustomer] = useState("")

    const [IshaveResponEmp, setIshaveResponEmp] = useState(false)
    const [sRefVOCCode, setsRefVOCCode] = useState("")
    const [nStatusID, setnStatusID] = useState(0)
    const [nHistoryStatusID, setnHistoryStatusID] = useState(0)
    const [DataRowNote, setDataRowNote] = useState([] as any)       //List Note
    const [DataRowResolve, setDataRowResolve] = useState([] as any)       //List Note
    const [DataRowUpdatePlan, setDataRowUpdatePlan] = useState([] as any)       //List Note

    const [IsAllowEmailAlert, setIsAllowEmailAlert] = useState(false)
    const [IsCheckTel, setIsCheckTel] = useState(false)
    const [IsOtherVOCService, setIsOtherVOCService] = useState(false)
    const [IsAddAddress, setIsAddAddress] = useState(false)
    const [IsOtherRequest, setIsOtherRequest] = useState(false)

    const [isInputTelRequire, setisInputTelRequire] = useState(false)
    const [IsRequireObjInprogress, setIsRequireObjInprogress] = useState(false)
    const [IsRequireOtherInprogress, setIsRequireOtherInprogress] = useState(false)

    const [IsOpenRejectPart, setIsOpenRejectPart] = useState(false) // ผจ.ส่วน Reject
    const [IsReferVOC, setIsReferVOC] = useState(false)
    const [IsCreateByBA, setIsCreateByBA] = useState(true)
    const [IsEmpRespon, setIsEmpRespon] = useState(false)
    const [IsBAowner, setIsBAowner] = useState(false)
    const [IsSuperAdmin, setIsSuperAdmin] = useState(false)
    const [IsBAAdmin, setIsBAAdmin] = useState(false)
    const [IsRoleDM, setIsRoleDM] = useState(false)
    const [IsRoleVP, setIsRoleVP] = useState(false)

    const [IsOtherExternalPTT, setIsOtherExternalPTT] = useState(false)
    const [sTypeResponPerson, setsTypeResponPerson] = useState("22")
    const [sResponPerson, setsResponPerson] = useState('25')
    const [objPermission, setobjPermission] = useState(null as any)

    //SnankBar
    const [IsOpenSnackbar, setIsOpenSnackbar] = useState(false)
    const [sSeveritySnackbar, setsSeveritySnackbar] = useState("success")
    const [sMessageSnackbar, setsMessageSnackbar] = useState(null) as any

    //#region  state component CpnDataRequest
    const onClearFile = useRef(null);

    const [arrAttachment, setarrAttachment] = useState([] as any)


    //#endregion

    //State Map
    const [IsOpenMap, setIsOpenMap] = useState(false)
    const [isSetMap, setIsSetMap] = useState(false)
    const [oLocationCurrent, setoLocationCurrent] = useState({
        lat: null,
        lng: null,
    })
    const [sLocation, setsLocation] = useState({
        Latitude: null,
        Longitude: null,
        Address: null,
    })

    const [Option, setOption] = useState({
        lstBA: [],
        lstCompany: [],
        lstCompanyAddress: [],
        lstVOCType: [],
        lstVOCService: [],
        lstTel: [],
        lstContactType: [],
        lstTypeResolve: [],
        lstOutPTT: [],
        lstTypeCompliant: [],
        lstTypeResponPerson: [],
        lstResponPerson: [],
        lstStatus: [],
        lstSolution: [],
        lstSolutionPart: [],
        lstSolutionDepart: [],
        lstSolutionInprogress: [],
    })
    //#endregion

    //#region  Form
    let objSchema = {
        //1
        sJobCode: yupFormSchemas.object("เลขที่ใบงาน", { required: false }),
        sVOCFormCode: yupFormSchemas.string("เลขที่ใบแจ้ง", { required: false }),
        sReferVOCFormCode: yupFormSchemas.object("เลขที่ใบแจ้งอ้างอิง", { required: false }),
        oCustomer: yupFormSchemas.object("ลูกค้า", { required: false }),
        oBA: yupFormSchemas.object("กลุ่มตลาด", { required: false }),
        oCompany: yupFormSchemas.object("บริษัท", { required: false }),
        oAddress: yupFormSchemas.object("ที่อยู่/สถานที่เกิดเหตุ", { required: false }),
        sAddress: yupFormSchemas.string("ที่อยู่/สถานที่เกิดเหตุ", { required: false }),
        oVOCType: yupFormSchemas.object("ประเภท", { required: false }),
        oVOCService: yupFormSchemas.object("บริการที่ต้องการ / ปัญหาที่พบ", { required: false }),
        sOtherVOCService: yupFormSchemas.string("บริการที่ต้องการ / ปัญหาที่พบ (อื่นๆ)", { required: false }),
        sDetail: yupFormSchemas.string("รายละเอียด", { required: false }),
        oTel: yupFormSchemas.object("หมายเลขโทรศัพท์", { required: false }),
        sInputTel: yupFormSchemas.string("หมายเลขโทรศัพท์", { required: false }),
        oNoticeChannel: yupFormSchemas.object("ช่องทางที่รับแจ้ง", { required: false }),
        sDateIssue: yupFormSchemas.string("วันที่แจ้ง", { required: false }),
        sTimeIssue: yupFormSchemas.string("เวลาที่แจ้ง", { required: false }),
        sNoticeEmail: yupFormSchemas.string("ส่งอีเมลแจ้งเตือนลูกค้า", { required: false }),
        //2
        oTypeResolve: yupFormSchemas.object("ประเภทสำหรับแก้ไขปัญหา", { required: false }),
        oReqInprogress: yupFormSchemas.object("ข้อร้องเรียนเกี่ยวกับการดำเนินงาน", { required: false }),
        sReqInprogress: yupFormSchemas.string("ข้อร้องเรียนเกี่ยวกับการดำเนินงาน (อื่นๆ)", { required: false }),
        oTypeCompliant: yupFormSchemas.object("GBU Compliant Type", { required: false }),
        //3
        sTypeResponPerson: yupFormSchemas.string("ประเภทผู้รับผิดชอบ", { required: false }),
        sResponPerson: yupFormSchemas.string("ผู้รับผิดชอบ", { required: false }),
        oAutoUnitInGBU: yupFormSchemas.object("หน่วยงาน", { required: false }),
        oAutoEmpInGBU: yupFormSchemas.object("ผู้รับผิดชอบแก้ไข", { required: false }),   //ผจ.ส่วน
        oAutoUnitInPTT: yupFormSchemas.object("หน่วยงาน", { required: false }),
        oAutoEmpInPTT: yupFormSchemas.object("ผู้รับผิดชอบแก้ไข", { required: false }),     //ผจ.ส่วน
        oUnitExternalPTT: yupFormSchemas.object("บุคคล", { required: false }),
        sExternalPTT: yupFormSchemas.string("หน่วยงาน (อื่นๆ)", { required: false }),
        //4
        oStatus: yupFormSchemas.object("สถานะ", { required: false }),
        //5
        sSolution: yupFormSchemas.string("แนวทางการแก้ไข", { required: false }),
        //6s
        sResolveDetail: yupFormSchemas.string("รายละเอียดการแก้ไข", { required: false }),
        //7
        sPlanDetail: yupFormSchemas.string("รายละเอียด", { required: false }),
    }

    const schema = yup.object().shape(Object.assign(objSchema, schemaObj));
    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
    })

    //#endregion

    useEffect(() => {
        if (params['sID'] != null) {
            GetNewInitailFormVOC()
            GetDataVOCID();
        }
    }, [])

    const GetDataVOCID = async () => {
        BlockUI();
        await AxiosGet(`VOC/VOCFormDataByID`, { sVOCFormID: params['sID'] }, (res) => {
            UnBlockUI();
            ResultAPI(res, null, async () => {
                setIsEmpRespon(res.IsEmpRespon)
                setIsBAowner(res.IsBAowner)
                setIsSuperAdmin(res.IsSuperAdmin)
                setIsBAAdmin(res.IsBAAdmin)
                setIsRoleDM(res.IsRoleDM)
                setIsRoleVP(res.IsRoleVP)
                let Result = res?.result?.data
                if (Result != null) {
                    setnStatusID(Result.nStatusID)

                    form.setValue("sJobCode", Result.sJobCode)
                    form.setValue("sVOCFormCode", Result.sVOCFormCode)
                    setnJobTypeID(Result.nJobTypeID ?? 0)
                    form.setValue("sReferVOCFormCode", Result.oRefVOCCode?.label == null ? null : Result.oRefVOCCode)
                    
                    form.setValue("oCustomer", Result.objCustomer?.label == null ? null : Result.objCustomer)
                    setsCustomer(Result?.objCustomer?.label ?? "")
                    form.setValue("oBA", Result.objOwnerBA?.label == null ? null : Result.objOwnerBA)
                    form.setValue("oCompany", Result.objCompany?.label == null ? null : Result.objCompany)
                    form.setValue("oAddress", Result.objAddr?.label == null ? null : Result.objAddr)

                    form.setValue("oVOCType", Result.objVOCType?.label == null ? null : Result.objVOCType)
                    form.setValue("oVOCService", Result.objVOCService?.label == null ? null : Result.objVOCService)
                    //Condition show other input
                    form.setValue("sOtherVOCService", Result.sVOCServiceOther ?? null)
                    setIsOtherVOCService(Result?.objVOCService?.IsOther == true ? true : false)

                    form.setValue("sDetail", Result.sDetail)
                    form.setValue("oTel", Result.objTel?.label == null ? null : Result.objTel)
                    setIsCheckTel(Result.IsAllowContact)
                    form.setValue("oNoticeChannel", Result.objContactType?.label == null ? null : Result.objContactType)
                    setarrAttachment(Result.lstFormFile)
                    //dIssueDate
                    let dIssueDate = moment(Result.dIssueDate);
                    let dTimeIssue = dIssueDate.format("HH:mm");
                    form.setValue("sDateIssue", dIssueDate)
                    // form.setValue("sTimeIssue", dTimeIssue)
                    form.setValue("sTimeIssue", dIssueDate)
                    setIsAllowEmailAlert(Result.IsAllowEmailAlert ?? false)
                    form.setValue("sNoticeEmail", Result.IsAllowEmailAlert == true ? "1" : "0")

                    //2
                    let objFormData = Result.objFormData;
                    form.setValue("oTypeResolve", objFormData.objComplaintIssueType?.label == null ? null : objFormData.objComplaintIssueType)
                    form.setValue("oReqInprogress", objFormData.objComplaintIssueSubType?.label == null ? null : objFormData.objComplaintIssueSubType)
                    form.setValue("sReqInprogress", objFormData.sComplaintIssueSubTypeOther)
                    form.setValue("oTypeCompliant", objFormData.objGBUComplaintType?.label == null ? null : objFormData.objGBUComplaintType)

                    form.setValue("oTypeRequest", objFormData.objRequestType?.label == null ? null : objFormData.objRequestType)
                    form.setValue("sRequestTypeOther", objFormData.sRequestTypeOther ?? null)
                    setIsOtherRequest(Result?.objRequestType?.IsOther == true ? true : false)

                    //3
                    form.setValue("sTypeResponPerson", objFormData.nResponsibleTypeID + "")
                    form.setValue("sResponPerson", objFormData.nResponsibleID + "")
                    setsTypeResponPerson(objFormData.nResponsibleTypeID + "")
                    setsResponPerson(objFormData.nResponsibleID + "")
                    form.setValue("oAutoUnitInGBU", objFormData.objResponsibleUnit?.label == null ? null : objFormData.objResponsibleUnit)
                    form.setValue("oAutoEmpInGBU", objFormData.objResponsibleEmp?.label == null ? null : objFormData.objResponsibleEmp)
                    form.setValue("oAutoUnitInPTT", objFormData.objResponsibleUnit?.label == null ? null : objFormData.objResponsibleUnit)
                    form.setValue("oAutoEmpInPTT", objFormData.objResponsibleEmp?.label == null ? null : objFormData.objResponsibleEmp)
                    setIshaveResponEmp(objFormData.objResponsibleEmp?.label == null ? false : true)

                    form.setValue("oUnitExternalPTT", Result.objOtherPTT?.label == null ? null : Result.objOtherPTT)
                    form.setValue("sExternalPTT", Result.sOtherPTT ?? null)

                    setIsReferVOC(Result.isReferVOC ?? false)
                    setIsCreateByBA(Result.isCreateByBA ?? false)
                    setobjPermission({ ...objPermission, ...{ Responsible: { isShow: true, isDisable: true, isEdit: false } } })

                }

            })
        })
    }


    const GetNewInitailFormVOC = async () => {
        BlockUI();

        let oOptionVOC = {
            lstBA: [],
            lstCompany: [],
            lstCompanyAddress: [],
            lstVOCType: [],
            lstVOCService: [],
            lstTel: [],
            lstContactType: [],
            lstOutPTT: [],
            lstTypeResolve: [],
            lstTypeCompliant: [],
            lstReqInprogress: [],
            lstTypeResponPerson: [],
            lstResponPerson: [],
            lstStatus: [],
            lstSolution: [],
        };

        //#region  New

        await AxiosGet(`MasterData/GetMasterData`, { "nMasterTypeID": 6 }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstTypeResponPerson: res.result?.data || [] }
            })
        });
        await AxiosGet(`MasterData/GetMasterData`, { "nMasterTypeID": 7 }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstResponPerson: res.result?.data || [] }
            })
        });

        await AxiosGet(`MasterData/GetMasterData`, { "nMasterTypeID": 8 }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstOutPTT: res.result?.data || [] }
            })
        });
        //#endregion

        await onSetOption(oOptionVOC);
    }

    
    const onSetOption = async (paramOption) => {
        setOption(paramOption)
        UnBlockUI();
    }

    const onGotoBack = () => {
        let sUrl = "/Backend/MyCreateVOCList";
        navigate(sUrl);
    }

    return (
        <>
            <InnerHeadRoutes
                iconMUI={<BiEdit style={{ fontSize: '1.5em' }} />}
                labal_Head="สร้างใบงาน"
            />
            <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" style={{ marginTop: '0' }}>
                <Grid item xs={12} md={10}>
                    <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
                        <Grid item xs={12}> {/** ข้อมูลข้อร้องเรียน */}
                            <FormProvider {...form}>
                                <CpnDataRequest
                                    form={form}
                                    header={ nJobTypeID == 1 ? "ข้อมูลข้อร้องเรียน" : "ข้อมูลข้อร้องขอ"}
                                    arrAttachment={arrAttachment}
                                    setarrAttachment={setarrAttachment}
                                    Option={Option}
                                    setIsCheckTel={setIsCheckTel}
                                    IsCheckTel={IsCheckTel}
                                    IsOtherVOCService={IsOtherVOCService}
                                    setIsOtherVOCService={setIsOtherVOCService}
                                    IsAddAddress={IsAddAddress}
                                    setIsAddAddress={setIsAddAddress}
                                    setIsOpenMap={setIsOpenMap}     //for Add address
                                    sLocation={sLocation}
                                    setsLocation={setsLocation}
                                    setoLocationCurrent={setoLocationCurrent}
                                    oLocationCurrent={oLocationCurrent}
                                    isSetMap={isSetMap}
                                    setIsSetMap={setIsSetMap}
                                    setisInputTelRequire={setisInputTelRequire}
                                    onClearFile={onClearFile}
                                    IsCreateByBA={IsCreateByBA}
                                    nStatusID={nStatusID}
                                    IsAllowEmailAlert={IsAllowEmailAlert}
                                    sMode={sMode}
                                    objPermission={objPermission}
                                />
                            </FormProvider>
                        </Grid>
                        {
                            nJobTypeID == 1
                                ?
                                <Grid item xs={12} > {/** ข้อมูลจำแนกประเภทข้อร้องเรียน */}
                                    <FormProvider {...form}>
                                        <CpnTypeRequestComplaint
                                            form={form}
                                            Option={Option}
                                            setIsRequireObjInprogress={setIsRequireObjInprogress}
                                            setIsRequireOtherInprogress={setIsRequireOtherInprogress}
                                            nStatusID={nStatusID}
                                            sMode={sMode}
                                            objPermission={objPermission}
                                        />
                                    </FormProvider>
                                </Grid>
                                : null
                        }
                        {
                            nJobTypeID == 2
                                ?
                                <Grid item xs={12} > {/** ข้อมูลจำแนกประเภทข้อร้องเรียน */}
                                    <FormProvider {...form}>
                                        <CpnTypeRequest
                                            form={form}
                                            Option={Option}
                                            nStatusID={nStatusID}
                                            sMode={sMode}
                                            objPermission={objPermission}
                                            IsOtherRequest={IsOtherRequest}
                                            setIsOtherRequest={setIsOtherRequest}
                                        />
                                    </FormProvider>
                                </Grid>
                                : null
                        }
                        <Grid item xs={12} > {/** ข้อมูลผู้รับผิดชอบแก้ไข */}
                            <FormProvider {...form}>
                                <CpnResponPersonNew
                                    form={form}
                                    Option={Option}
                                    nStatusID={nStatusID}
                                    IsRoleDM={IsRoleDM}
                                    IsRoleVP={IsRoleVP}
                                    sMode={sMode}
                                    sTypeResponPerson={sTypeResponPerson}
                                    setsTypeResponPerson={setsTypeResponPerson}
                                    sResponPerson={sResponPerson}
                                    setsResponPerson={setsResponPerson}
                                    setIsOtherExternalPTT={setIsOtherExternalPTT}
                                    IshaveResponEmp={IshaveResponEmp}
                                    objPermission={objPermission}
                                    IsShowAll = {true}
                                />
                            </FormProvider>
                        </Grid>
                        <Grid item xs={12} >
                            <FormProvider {...form}>
                                <CpnAlertEmail
                                    form={form}
                                    nStatusID={nStatusID}
                                    IsAllowEmailAlert={IsAllowEmailAlert}
                                    objPermission={objPermission}
                                    sMode={sMode}
                                    sReferFrom={"voc"}
                                />
                            </FormProvider>
                        </Grid>

                        <Grid item xs={12} style={{ display: nStatusID != 0 && sVOCFormID != null && !Layout1300 ? '' : 'none' }}>
                            <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
                                <Grid item xs={12}>
                                    <VerticalStepper sVOCFormID={sVOCFormID} />
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* Button Action */}
                        <Grid item xs={12} >
                            <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" >
                                <Grid item>
                                    <BtnBack onClick={() => { onGotoBack() }} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {/* Stepper */}
                <Grid item xs={12} md={2} style={{ display: nStatusID != 0 && sVOCFormID != null && Layout1300 ? '' : 'none' }}>
                    <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
                        <Grid item xs={12}>
                            <VerticalStepper sVOCFormID={sVOCFormID} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <SnackbarCustom
                IsOpen={IsOpenSnackbar}
                Severity={sSeveritySnackbar}
                OnClose={() => { setIsOpenSnackbar(false) }}
                Message={sMessageSnackbar}
            />
        </>
    )
}

export default ReferDetailVOC




